export class ImageComparisonSlider {
    public static start(): void {
        const slider = document.querySelector(
            '.gw-comparison__slider'
        ) as HTMLInputElement;

        if (slider) {
            slider.addEventListener('input', () => {
                const container = slider.closest('.gw-comparison__container');
                if (!container) return;

                const divider = container.querySelector<HTMLElement>(
                    '.gw-comparison__divider'
                );

                const sliderValue = parseFloat(slider.value);
                const percent = `${sliderValue}%`;

                if (divider) {
                    divider.style.width = percent;
                }
            });
        }
    }
}
